export default function (http) {
    return {


        queryByPage(data) {
            return http.json({
                url: `/rep/kepu/query?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            });
        },

        getInfo(data) {
            return http.json({
                url: `/rep/kepu/get?id=${data.id}`,
                data
            })
        },
        queryAll(data) {
            return http.json({
                url: `/rep/kepu/queryAll`,
                data
            })
        },
        saveInfo(data) {
            return http.json({
                url: `/rep/kepu/save`,
                data
            })
        },
        getOne(data) {
            return http.json({
                url: `/rep/kepu/getOne`,
                data
            })
        },


        delete(data) {
            return http.json({
                url: `/rep/kepu/delete`,
                data
            })
        },

        updateState(data) {
            return http.json({
                url: `/rep/kepu/updateState`,
                data
            })
        },
        updateSuggested(data) {
            return http.json({
                url: `/rep/kepu/updateSuggested`,
                data
            })
        },
    }
}





// WEBPACK FOOTER //
// ./src/configure/http/api/enroll/kepu.js